"use client";

import { c as _c } from "react/compiler-runtime";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
// import { CheckIcon, ChevronRightIcon, CircleIcon } from "lucide-react";
import type { ComponentProps } from "react";
import { cn } from "../lib/cn";
export function DropdownMenu(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <DropdownMenuPrimitive.Root data-slot="dropdown-menu" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}

// function DropdownMenuPortal({
// 	...props
// }: ComponentProps<typeof DropdownMenuPrimitive.Portal>) {
// 	return (
// 		<DropdownMenuPrimitive.Portal data-slot="dropdown-menu-portal" {...props} />
// 	);
// }

export function DropdownMenuTrigger(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <DropdownMenuPrimitive.Trigger data-slot="dropdown-menu-trigger" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export function DropdownMenuContent(t0) {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      sideOffset: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const sideOffset = t1 === undefined ? 4 : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 bg-popover text-popover-foreground data-[state=closed]:animate-out data-[state=open]:animate-in z-50 max-h-(--radix-dropdown-menu-content-available-height) min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border p-1 shadow-md", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== sideOffset || $[8] !== t2) {
    t3 = <DropdownMenuPrimitive.Portal><DropdownMenuPrimitive.Content data-slot="dropdown-menu-content" sideOffset={sideOffset} className={t2} {...props} /></DropdownMenuPrimitive.Portal>;
    $[6] = props;
    $[7] = sideOffset;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}

// function DropdownMenuGroup({
// 	...props
// }: ComponentProps<typeof DropdownMenuPrimitive.Group>) {
// 	return (
// 		<DropdownMenuPrimitive.Group data-slot="dropdown-menu-group" {...props} />
// 	);
// }

export function DropdownMenuItem(t0) {
  const $ = _c(12);
  let className;
  let inset;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      inset,
      variant: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = inset;
    $[3] = props;
    $[4] = t1;
  } else {
    className = $[1];
    inset = $[2];
    props = $[3];
    t1 = $[4];
  }
  const variant = t1 === undefined ? "default" : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("data-[variant=destructive]:*:[svg]:!text-destructive focus:bg-accent focus:text-accent-foreground data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive dark:data-[variant=destructive]:focus:bg-destructive/20 relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== inset || $[8] !== props || $[9] !== t2 || $[10] !== variant) {
    t3 = <DropdownMenuPrimitive.Item data-slot="dropdown-menu-item" data-inset={inset} data-variant={variant} className={t2} {...props} />;
    $[7] = inset;
    $[8] = props;
    $[9] = t2;
    $[10] = variant;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}

// function DropdownMenuCheckboxItem({
// 	className,
// 	children,
// 	checked,
// 	...props
// }: ComponentProps<typeof DropdownMenuPrimitive.CheckboxItem>) {
// 	return (
// 		<DropdownMenuPrimitive.CheckboxItem
// 			data-slot="dropdown-menu-checkbox-item"
// 			className={cn(
// 				"relative flex cursor-default select-none items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0",
// 				className,
// 			)}
// 			checked={checked ?? false}
// 			{...props}
// 		>
// 			<span className="pointer-events-none absolute left-2 flex size-3.5 items-center justify-center">
// 				<DropdownMenuPrimitive.ItemIndicator>
// 					<CheckIcon className="size-4" />
// 				</DropdownMenuPrimitive.ItemIndicator>
// 			</span>
// 			{children}
// 		</DropdownMenuPrimitive.CheckboxItem>
// 	);
// }

// function DropdownMenuRadioGroup({
// 	...props
// }: ComponentProps<typeof DropdownMenuPrimitive.RadioGroup>) {
// 	return (
// 		<DropdownMenuPrimitive.RadioGroup
// 			data-slot="dropdown-menu-radio-group"
// 			{...props}
// 		/>
// 	);
// }

// function DropdownMenuRadioItem({
// 	className,
// 	children,
// 	...props
// }: ComponentProps<typeof DropdownMenuPrimitive.RadioItem>) {
// 	return (
// 		<DropdownMenuPrimitive.RadioItem
// 			data-slot="dropdown-menu-radio-item"
// 			className={cn(
// 				"relative flex cursor-default select-none items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0",
// 				className,
// 			)}
// 			{...props}
// 		>
// 			<span className="pointer-events-none absolute left-2 flex size-3.5 items-center justify-center">
// 				<DropdownMenuPrimitive.ItemIndicator>
// 					<CircleIcon className="size-2 fill-current" />
// 				</DropdownMenuPrimitive.ItemIndicator>
// 			</span>
// 			{children}
// 		</DropdownMenuPrimitive.RadioItem>
// 	);
// }

// function DropdownMenuLabel({
// 	className,
// 	inset,
// 	...props
// }: ComponentProps<typeof DropdownMenuPrimitive.Label> & {
// 	inset?: boolean;
// }) {
// 	return (
// 		<DropdownMenuPrimitive.Label
// 			data-slot="dropdown-menu-label"
// 			data-inset={inset}
// 			className={cn(
// 				"px-2 py-1.5 font-medium text-sm data-[inset]:pl-8",
// 				className,
// 			)}
// 			{...props}
// 		/>
// 	);
// }

// function DropdownMenuSeparator({
// 	className,
// 	...props
// }: ComponentProps<typeof DropdownMenuPrimitive.Separator>) {
// 	return (
// 		<DropdownMenuPrimitive.Separator
// 			data-slot="dropdown-menu-separator"
// 			className={cn("-mx-1 my-1 h-px bg-border", className)}
// 			{...props}
// 		/>
// 	);
// }

// function DropdownMenuShortcut({
// 	className,
// 	...props
// }: ComponentProps<"span">) {
// 	return (
// 		<span
// 			data-slot="dropdown-menu-shortcut"
// 			className={cn(
// 				"ml-auto text-muted-foreground text-xs tracking-widest",
// 				className,
// 			)}
// 			{...props}
// 		/>
// 	);
// }

// function DropdownMenuSub({
// 	...props
// }: ComponentProps<typeof DropdownMenuPrimitive.Sub>) {
// 	return <DropdownMenuPrimitive.Sub data-slot="dropdown-menu-sub" {...props} />;
// }

// function DropdownMenuSubTrigger({
// 	className,
// 	inset,
// 	children,
// 	...props
// }: ComponentProps<typeof DropdownMenuPrimitive.SubTrigger> & {
// 	inset?: boolean;
// }) {
// 	return (
// 		<DropdownMenuPrimitive.SubTrigger
// 			data-slot="dropdown-menu-sub-trigger"
// 			data-inset={inset}
// 			className={cn(
// 				"flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-hidden focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[inset]:pl-8 data-[state=open]:text-accent-foreground",
// 				className,
// 			)}
// 			{...props}
// 		>
// 			{children}
// 			<ChevronRightIcon className="ml-auto size-4" />
// 		</DropdownMenuPrimitive.SubTrigger>
// 	);
// }

// function DropdownMenuSubContent({
// 	className,
// 	...props
// }: ComponentProps<typeof DropdownMenuPrimitive.SubContent>) {
// 	return (
// 		<DropdownMenuPrimitive.SubContent
// 			data-slot="dropdown-menu-sub-content"
// 			className={cn(
// 				"data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=closed]:animate-out data-[state=open]:animate-in",
// 				className,
// 			)}
// 			{...props}
// 		/>
// 	);
// }